<template>
  <div class="modal-wrapper">
    <BasicModal
      :title="'アンケート結果一覧'"
      :isShowModal=isShowModal
      :canCancel="true"
      @cancel="cancel">
      <article class="container">
        <!-- アンケート結果一覧 -->
        <section class="main-section" v-if="!isQDLoading && questionnaireData.length !== 0">
          <article class="table-wrapper">
            <QuestionnaireDataTable
              :questionnaireData="questionnaireData"/>
          </article>
        </section>

        <!-- アンケート結果がない場合 -->
        <section v-if="!isQDLoading && questionnaireData.length === 0">
          <p>このロボのアンケート結果はありません。</p>
        </section>
      </article>
    </BasicModal>
  </div>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import QuestionnaireDataTable from '@/components/ChatBot/organisms/QuestionnaireDataTable'

export default {
  components: {
    BasicModal,
    QuestionnaireDataTable
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: false,
      default: false
    },
    questionnaireData: {
      type: Array,
      required: false
    },
    isQDLoading: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-wrapper {
  .container {
    padding: 8px;
    height: 600px;
    display: flex;
    align-items: center;
    overflow: auto;
    section {
      width: 100%;
    }
  }
  .button-wrapper {
    margin-top: 16px;
  }
  .table-wrapper {
    display: flex;
    justify-content: center;
    height: 100%;
    position: relative;
    padding: 8px;
  }
  .main-section {
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/ModalQuestionnaireData.vue